import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Router from 'root/router';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Form from 'root/module/form';
import Modals from 'root/modals';
import View from 'view/base';
import View_Project_Categories from 'view/project/categories';

var Project_Edit = View.extend({
    categories: [],

    views: {
        project_categories: {}
    },

    logo_data: {
        name    : '',
        type    : '',
        content : ''
    },

    logo_deleted: false,

    events: {
        'click .submit'                    : 'submitForm',
        'submit .project-form'             : 'submit',
        'keyup .project-form input'        : 'checkChanges',
        'keyup .project-form textarea'     : 'checkChanges',
        'click .upload-logo'               : 'onSelectLogo',
        'click .logo-delete'               : 'onDeleteLogo',
        'change .project-logo'             : 'onUploadLogo',
        'click .project-delete'            : 'onDeleteProject'
    },

    dom_handlers: {
        onDeleteLogo: function(e) {
            this.logo_data = {
                name    : '',
                type    : '',
                content : ''
            };

            if (this.model.get('logo')) {
                this.logo_deleted = true;
            }

            this.$el.find('.project-logo-edit > img').remove();
            this.$el.find('.project-logo-edit .logo-delete').remove();
            this.$el.find('.project-logo-edit').append($('<div>').addClass('letter').text(this.model.get('name').charAt(0)));

            this.checkChanges();
        },

        onSelectLogo: function(e) {
            e.preventDefault();

            $('<input>')
                .attr('type', 'file')
                .attr('accept', 'image/png, image/jpeg')
                .addClass('project-logo hidden')
                .appendTo(this.$el).click();
        },

        onUploadLogo: function(e) {
            this.$el.find('.project-logo').remove();

            if (!e.target.files || !e.target.files.length) {
                return;
            }

            var result = Util.readImage(e.target.files[0], 1, _.bind(function(file_name, file_type, file_content) {
                this.logo_data = {
                    name    : file_name,
                    type    : file_type,
                    content : file_content
                };

                this.logo_deleted = false;

                if (this.model.get('logo')) {
                    this.$el.find('.project-logo-edit img').attr('src', file_content);
                } else {
                    this.$el.find('.project-logo-edit').append($('<img>').attr('src', file_content));
                    this.$el.find('.project-logo-edit').append($('<div>').addClass('logo-delete').html('<i class="fas fa-times"></i>'));
                    this.$el.find('.project-logo-edit').find('.letter').remove();
                }

                this.checkChanges();
            }, this));

            if (result === true) {
                this.$el.find('.avatar').addClass('loader loader-small');
            } else {
                UI.error(result);
            }
        },

        checkChanges: function(e) {
            this.checkChanges();
        },

        submitForm: function(e) {
            this.$el.find('form.project-form button[type="submit"]').click();
        },

        submit: function(e) {
            var categories_data = Form.getData(this.$el.find('.project-categories'));

            var data = _.extend({
                    project_id: this.model.id
                },
                Form.getData(this.$el.find('.project-form')),
                categories_data
            );

            if (this.logo_data.content) {
                data.logo_name    = this.logo_data.name;
                data.logo_type    = this.logo_data.type;
                data.logo_content = this.logo_data.content;
            } else if (this.model.get('logo') && this.logo_deleted) {
                data.logo_delete = true;
            }

            if (this.model.isFeedback() && !categories_data.categories) {
                UI.error('Please add a category');
                return;
            }

            this.$el.find('.submit').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action:  'project/update',
                data:    data,
                success: (response) => {
                    if (response && response.feedback_categories) {
                        // remove old categories
                        var old_categories = Cache.feedback_category.where({project_id: this.model.id});
                        old_categories.forEach((model) => {
                            Cache.feedback_category.remove(model);
                        });

                        // add new categories
                        Cache.feedback_category.add(response.feedback_categories);

                        // re-render categories
                        var categories = [];

                        Cache.feedback_category.where({project_id: this.model.id}).forEach((category) => {
                            categories.push(category.get('name'));
                        });

                        this.categories = categories;

                        if (this.views.project_categories) {
                            this.views.project_categories.setCategories(_.extend([], categories));
                            this.views.project_categories.render();
                        }

                        this.trigger('success');
                    }

                    if (this.model.get('project_key') !== response.project.project_key && Cache.app.isProjectPage()) {
                        var path = window.location.pathname.split('/');
                        path[1] = response.project.project_key;

                        Router.navigate(path.join('/'), {trigger: false});
                    }

                    this.model.set(response.project);

                    UI.success('Project settings updated');
                },
                complete: () => {
                    this.$el.find('.submit').removeClass('loading');
                }
            });
        },

        onDeleteProject: function(e) {
            Modals.deleteProject(this.model.id);
        }
    },

    checkChanges: function() {
        var has_changed = false;
        var is_key_valid = false;
        var form_data = Form.getData(this.$el.find('.project-form'));

        if (!has_changed) {
            if (this.logo_data.content) {
                has_changed = true;
            }
        }

        if (!has_changed) {
            if (form_data.name        !== this.model.get('name') ||
                form_data.project_key !== this.model.get('project_key') ||
                form_data.description !== this.model.get('description')
            ) {
                has_changed = true;
            }
        }

        if (!has_changed) {
            var categories = Form.getData(this.$el.find('.project-categories'))['categories'];
            categories = categories ? categories.split(',') : [];

            if (_.difference(categories, this.categories).length || _.difference(this.categories, categories).length) {
                has_changed = true;
            }
        }

        if (!has_changed) {
            if (this.model.get('logo') && this.logo_deleted) {
                has_changed = true;
            }
        }

        // project key must be alphanumeric
        if (!Util.isAlphanumeric(form_data.project_key)) {
            is_key_valid = true;
            this.$el.find('.project-key-taken').html('<i class="fa-solid fa-circle-exclamation"></i> The project key must be alphanumeric.');
        }

        // check key duplication
        Cache.project.each((model) => {
            if (model.id !== this.model.id && model.get('project_key').toLowerCase() === form_data.project_key.toLowerCase()) {
                is_key_valid = true;

                this.$el.find('.project-key-taken').html('<i class="fa-solid fa-circle-exclamation"></i> Project "' + model.escape('name') + '" uses this project key.');
            }
        });

        if (!is_key_valid) {
            this.$el.find('.project-key-taken').text('');
        }

        this.$el.find('button.submit').prop('disabled', !has_changed || is_key_valid);
    },

    loadFeedbackCategories: function() {
        if (this.model.id === Cache.default_project_id) {
            this.categories = [];

            _.each(Cache.feedback_category.where({project_id: Cache.default_project_id}), function(model) {
                this.categories.push(model.get('name'));
            }, this);

            this.views.project_categories = new View_Project_Categories({categories: _.extend([], this.categories), add_new: true, edit: true});
            this.views.project_categories.render().$el.appendTo(this.$el.find('.project-categories'));

            this.views.project_categories.on('change', this.checkChanges.bind(this));
        } else {
            Cache.app.request({
                action: 'feedback\\category/load',
                context: this,
                data: {
                    project_id: this.model.id
                },
                success: function(response) {
                    this.categories = [];

                    _.each(response, function(category) {
                        this.categories.push(category.name);
                    }, this);

                    this.views.project_categories = new View_Project_Categories({categories: _.extend([], this.categories), add_new: true, edit: true});
                    this.views.project_categories.render().$el.appendTo(this.$el.find('.project-categories'));

                    this.views.project_categories.on('change', this.checkChanges.bind(this));
                }
            });
        }
    },

    render: function() {
        var content = '';

        content += '<div class="project-settings-inner">' +
                   '<div class="grid-8-4">' +
                        '<div>' +
                            '<form class="project-form form-fluid">' +
                                '<button type="submit" class="hidden"></button>' +
                                '<div class="row">' +
                                    '<div class="field-label">Project Name</div>' +
                                    '<input type="text" class="solid medium" name="name" maxlength="100" placeholder="My Web App" required>' +
                                '</div>' +
                                '<div class="row">' +
                                    '<div class="field-label">Project Key</div>' +
                                    '<input type="text" class="solid medium" name="project_key" maxlength="10" minlength="2" required>' +
                                    '<div class="flex-between-top">' +
                                        '<div class="project-key-taken text-danger text-medium margin-top-4 padding-right-24"></div>' +
                                        '<div class="maxlength-help"></div>' +
                                    '</div>' +
                                '</div>' +
                                '<div class="row">' +
                                    '<div class="field-label">Description</div>' +
                                    '<textarea class="solid compact" name="description" rows="6" maxlength="1000" placeholder="Enter a short description of your project"></textarea>' +
                                    '<div class="maxlength-help"></div>' +
                                '</div>' +
                            '</form>' +
                        '</div>' +
                        '<div class="flex-end-top padding-right-24">' +
                            '<div class="project-logo-edit">' +
                                (this.model.get('logo') ?
                                '<img src="' + this.model.get('logo') + '">' +
                                '<div class="logo-delete"><i class="fas fa-times"></i></div>' :
                                '<div class="letter">' + this.model.get('name').charAt(0) + '</div>') +
                                '<a class="upload-logo" href="#">Upload Logo</a>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +

                    (this.model.isFeedback() ?
                    '<div class="divider-24"></div>' +

                    '<div class="form-fluid">' +
                        '<div class="field-label">Category</div>' +
                        '<div>' +
                            '<form class="project-categories"></form>' +
                        '</div>' +
                    '</div>' : '') +

                    '</div>' +

                    '<div class="project-settings-save flex-between">' +
                        '<button type="button" class="project-delete tertiary medium">Delete Project</button>' +
                        '<button class="primary submit medium" disabled>Save Changes</button>' +
                    '</div>';

        this.$el.html(content);

        this.loadFeedbackCategories();

        Form.setData(this.$el.find('.project-form'), this.model.attributes);

        return this;
    }
});

export default Project_Edit;